// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3Vpaq","sub-header":"sub-header__3qOa8","sub-header-text":"sub-header-text___2kip"};